import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import SummaryCard from 'components/DetailWidgets/SummaryCard'

export default withTranslation()(function OverviewTab({ t, campaign }) {
  const detailItems = [
    { icon: UIcons.UilLink, label: t('rewardAds.detail.overview.callback_url'), value: campaign.callbackUrl },
    { icon: UIcons.UilLocationArrow, label: t('rewardAds.detail.overview.cta_message'), value: campaign.ctaMessage },
    { icon: UIcons.UilInfoCircle, label: t('rewardAds.detail.overview.description'), value: campaign.description },
    { icon: UIcons.UilInfoCircle, label: t('rewardAds.detail.overview.campaign_id'), value: campaign.campaignId },
    { icon: UIcons.UilCalendarAlt, label: t('rewardAds.detail.overview.created_date'), value: campaign.createdAt },
    { icon: UIcons.UilClockThree, label: t('rewardAds.detail.overview.last_updated'), value: campaign.updatedAt }
  ]

  const targetItems = [
    { icon: UIcons.UilUsersAlt, label: t('rewardAds.detail.overview.interests'), value: campaign.targetSummary.interests },
    { icon: UIcons.UilLocationPinAlt, label: t('rewardAds.detail.overview.location'), value: campaign.targetSummary.location },
    { icon: UIcons.UilShieldCheck, label: t('rewardAds.detail.overview.ip_targeting'), value: campaign.targetSummary.ipTargeting }
  ]

  const scheduleItems = [
    { icon: UIcons.UilCalendarAlt, label: t('rewardAds.detail.overview.start_date'), value: campaign.scheduleSummary.startDate },
    { icon: UIcons.UilCalendarAlt, label: t('rewardAds.detail.overview.end_date'), value: campaign.scheduleSummary.endDate },
    { icon: UIcons.UilPlayCircle, label: t('rewardAds.detail.overview.days_to_display'), value: campaign.scheduleSummary.daysToDisplay },
    { icon: UIcons.UilClockThree, label: t('rewardAds.detail.overview.hours_to_display'), value: campaign.scheduleSummary.hoursToDisplay },
    { icon: UIcons.UilSync, label: t('rewardAds.detail.overview.frequency'), value: campaign.scheduleSummary.frequency }
  ]

  const repeatItems = [
    { icon: UIcons.UilCalendarAlt, label: t('rewardAds.detail.overview.days_to_repeat'), value: campaign.repeatSummary.daysToRepeat },
    { icon: UIcons.UilClockThree, label: t('rewardAds.detail.overview.hours_to_repeat'), value: campaign.repeatSummary.hoursToRepeat }
  ]

  return (
    <div className="flex flex-col gap-4">
      <div className="grid md:grid-cols-2 gap-4">
        <div className="rounded-2xl border border-border-lines p-4">
          <div className="flex flex-col gap-4">
            {
              detailItems.map(({ icon: Icon, label, value }) => (
                <div key={label} className="flex items-start gap-2.5">
                  <Icon size={16} className="text-secondary shrink-0 mt-0.5" />
                  <div className="min-w-0">
                    <p className="text-xs text-secondary">{label}</p>
                    <p className="text-sm text-dark-blue break-words">{value}</p>
                  </div>
                </div>
              ))
            }
          </div>
        </div>

        <div className="rounded-2xl border border-border-lines p-4">
          <p className="text-xs font-semibold text-secondary tracking-wide uppercase mb-3">{t('rewardAds.detail.overview.video_asset')}</p>

          <div className="w-full aspect-video rounded-xl bg-dark-blue flex items-center justify-center mb-3 overflow-hidden">
            {
              campaign.thumbnailUrl
                ? <img src={campaign.thumbnailUrl} alt="" className="w-full h-full object-cover" />
                : <UIcons.UilPlayCircle size={48} className="text-white opacity-80" />
            }
          </div>

          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="text-sm text-dark-blue truncate">{campaign.video.name}</p>
              <p className="text-xs text-secondary">{campaign.video.format} • {campaign.video.duration} • {campaign.video.size}</p>
            </div>

            {
              campaign.mediaUrl
                ? (
                  <a
                    href={campaign.mediaUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-1.5 border border-border-lines rounded-full h-9 px-3.5 text-sm font-medium text-dark-blue whitespace-nowrap"
                  >
                    <UIcons.UilImport size={15} /> {t('rewardAds.detail.overview.download')}
                  </a>
                )
                : (
                  <button
                    type="button"
                    className="flex items-center gap-1.5 border border-border-lines rounded-full h-9 px-3.5 text-sm font-medium text-dark-blue whitespace-nowrap"
                  >
                    <UIcons.UilImport size={15} /> {t('rewardAds.detail.overview.download')}
                  </button>
                )
            }
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <SummaryCard title={t('rewardAds.detail.overview.target_summary')} items={targetItems} />
        <SummaryCard title={t('rewardAds.detail.overview.schedule_summary')} items={scheduleItems} />
        <SummaryCard title={t('rewardAds.detail.overview.repeat_summary')} items={repeatItems} />
      </div>
    </div>
  )
})
